// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /*
---------------
Font size variables 
---------------
*/
  /* @link https://utopia.fyi/type/calculator?c=320,16,1.2,1728,20,1.25,5,2,&s=0.75|0.5|0.25,1.5|2|3|4|6,s-l&g=s,l,xl,12 */

  /* Step -2: 11.1111px → 12.8px */
  --step--2: clamp(0.6944rem, 0.6705rem + 0.1199vw, 0.8rem);
  /* Step -1: 13.3333px → 16px */
  --step--1: clamp(0.8333rem, 0.7955rem + 0.1894vw, 1rem);
  /* Step 0: 16px → 20px */
  --step-0: clamp(1rem, 0.9432rem + 0.2841vw, 1.25rem);
  /* Step 1: 19.2px → 25px */
  --step-1: clamp(1.2rem, 1.1176rem + 0.4119vw, 1.5625rem);
  /* Step 2: 23.04px → 31.25px */
  --step-2: clamp(1.44rem, 1.3234rem + 0.5831vw, 1.9531rem);
  /* Step 3: 27.648px → 39.0625px */
  --step-3: clamp(1.728rem, 1.5659rem + 0.8107vw, 2.4414rem);
  /* Step 4: 33.1776px → 48.8281px */
  --step-4: clamp(2.0736rem, 1.8513rem + 1.1115vw, 3.0518rem);
  /* Step 5: 39.8131px → 61.0352px */
  --step-5: clamp(2.4883rem, 2.1869rem + 1.5072vw, 3.8147rem);

  /*
---------------
Color variables
---------------
*/

  --ocean-dark: #0a1628;
  --ocean-mid: #0d2137;
  --ocean-light: #1a3a5c;
  --wave: #1e5f8e;
  --cell-border: #2a6494;
  --ship-color: #4a5568;
  --hit-color: #e53e3e;
  --miss-color: #63b3ed;
  --preview-color: rgba(72, 187, 120, 0.6);
  --preview-invalid-color: rgba(245, 101, 101, 0.6);
  --text-light: #e2e8f0;
  --accent: #f6ad55;
}

body {
  min-height: 100vh;
  background-color: var(--ocean-dark);
  background-image: radial-gradient(
    ellipse at top,
    var(--ocean-light) 0%,
    var(--ocean-dark) 70%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 1rem;
  font-family: 'antaregular', sans-serif;
  color: var(--text-light);
}

header h1 {
  font-family: 'Press Start 2P', sans-serif;
  font-size: var(--step-3);
  color: var(--accent);
  text-align: center;
  letter-spacing: 0.1em;
  text-shadow: 0 0 20px rgba(246, 173, 85, 0.4);
  margin-top: 1rem;
  margin-bottom: 3rem;
}

main {
  display: flex;
  align-items: center;
  gap: 3rem;
  flex-wrap: wrap;
  justify-content: center;
}

.board-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.board-section h2 {
  font-family: 'Press Start 2P', sans-serif;
  font-size: var(--step-0);
  color: var(--miss-color);
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

#human-board,
#computer-board {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  width: fit-content;
  border: 2px solid var(--wave);
  border-radius: 4px;
  box-shadow: 0 0 30px rgba(30, 95, 142, 0.4);
}

.cell {
  width: 32px;
  height: 32px;
  border: 1px solid var(--cell-border);
  background-color: var(--ocean-mid);
  transition: background-color 0.2s ease;
  position: relative;
  overflow: hidden;
}

#computer-board .cell:hover {
  background-color: var(--wave);
  cursor: crosshair;
}

.ship {
  background-color: var(--ship-color);
  background-image: linear-gradient(135deg, #5a6578 0%, #3d4552 100%);
}

.miss {
  background-color: var(--miss-color);
  background-image: radial-gradient(circle, #90cdf4 0%, #63b3ed 100%);
  animation: splash 0.4s ease-out;
}

.hit {
  background-color: var(--hit-color);
  background-image: radial-gradient(circle, #fc8181 0%, #c53030 100%);
  animation: explosion 0.4s ease-out;
}

.hit::after {
  content: '💥';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.1rem;
  animation: pop 0.4s ease-out forwards;
}

.miss::after {
  content: '💧';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.9rem;
  animation: pop 0.4s ease-out forwards;
}

.preview {
  background-color: var(--preview-color) !important;
}

.preview-invalid {
  background-color: var(--preview-invalid-color) !important;
}

/* Animations */
@keyframes splash {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes explosion {
  0% {
    transform: scale(0.5);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes pop {
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 1;
  }
  70% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}

/* Controls */
.controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

#placement-info {
  font-size: var(--step-0);
  color: var(--accent);
  text-align: center;
  min-height: 2rem;
}

button {
  padding: 0.6rem 1.4rem;
  border: 2px solid var(--wave);
  border-radius: 6px;
  background-color: var(--ocean-light);
  color: var(--text-light);
  font-size: var(--step--1);
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: 0.05em;
}

button:hover {
  background-color: var(--wave);
  border-color: var(--accent);
  color: var(--accent);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

button:active {
  transform: translateY(0);
}

/* Dialog */
dialog {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 2px solid var(--accent);
  border-radius: 12px;
  background-color: var(--ocean-dark);
  color: var(--text-light);
  padding: 2rem;
  text-align: center;
  font-family: 'antaregular', sans-serif;
  font-size: var(--step-1);
  box-shadow: 0 0 40px rgba(246, 173, 85, 0.3);
  animation: dialogPop 0.3s ease-out;
}

dialog button {
  margin-top: 1rem;
  font-size: var(--step-0);
}

dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.7);
}

@keyframes dialogPop {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA;EACE;;;;CAID;EACC,wHAAwH;;EAExH,gCAAgC;EAChC,yDAAyD;EACzD,8BAA8B;EAC9B,uDAAuD;EACvD,wBAAwB;EACxB,oDAAoD;EACpD,0BAA0B;EAC1B,wDAAwD;EACxD,8BAA8B;EAC9B,yDAAyD;EACzD,iCAAiC;EACjC,0DAA0D;EAC1D,kCAAkC;EAClC,2DAA2D;EAC3D,kCAAkC;EAClC,2DAA2D;;EAE3D;;;;CAID;;EAEC,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,wCAAwC;EACxC,iDAAiD;EACjD,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC;;;;GAIC;EACD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,mEAAmE;AACrE;;AAEA;EACE,mCAAmC;EACnC,mEAAmE;EACnE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,mEAAmE;EACnE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,eAAe;AACf;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,mCAAmC;EACnC,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,wBAAwB;EACxB,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":[":root {\n  /*\n---------------\nFont size variables \n---------------\n*/\n  /* @link https://utopia.fyi/type/calculator?c=320,16,1.2,1728,20,1.25,5,2,&s=0.75|0.5|0.25,1.5|2|3|4|6,s-l&g=s,l,xl,12 */\n\n  /* Step -2: 11.1111px → 12.8px */\n  --step--2: clamp(0.6944rem, 0.6705rem + 0.1199vw, 0.8rem);\n  /* Step -1: 13.3333px → 16px */\n  --step--1: clamp(0.8333rem, 0.7955rem + 0.1894vw, 1rem);\n  /* Step 0: 16px → 20px */\n  --step-0: clamp(1rem, 0.9432rem + 0.2841vw, 1.25rem);\n  /* Step 1: 19.2px → 25px */\n  --step-1: clamp(1.2rem, 1.1176rem + 0.4119vw, 1.5625rem);\n  /* Step 2: 23.04px → 31.25px */\n  --step-2: clamp(1.44rem, 1.3234rem + 0.5831vw, 1.9531rem);\n  /* Step 3: 27.648px → 39.0625px */\n  --step-3: clamp(1.728rem, 1.5659rem + 0.8107vw, 2.4414rem);\n  /* Step 4: 33.1776px → 48.8281px */\n  --step-4: clamp(2.0736rem, 1.8513rem + 1.1115vw, 3.0518rem);\n  /* Step 5: 39.8131px → 61.0352px */\n  --step-5: clamp(2.4883rem, 2.1869rem + 1.5072vw, 3.8147rem);\n\n  /*\n---------------\nColor variables\n---------------\n*/\n\n  --ocean-dark: #0a1628;\n  --ocean-mid: #0d2137;\n  --ocean-light: #1a3a5c;\n  --wave: #1e5f8e;\n  --cell-border: #2a6494;\n  --ship-color: #4a5568;\n  --hit-color: #e53e3e;\n  --miss-color: #63b3ed;\n  --preview-color: rgba(72, 187, 120, 0.6);\n  --preview-invalid-color: rgba(245, 101, 101, 0.6);\n  --text-light: #e2e8f0;\n  --accent: #f6ad55;\n}\n\nbody {\n  min-height: 100vh;\n  background-color: var(--ocean-dark);\n  background-image: radial-gradient(\n    ellipse at top,\n    var(--ocean-light) 0%,\n    var(--ocean-dark) 70%\n  );\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2rem;\n  padding: 1rem;\n  font-family: 'antaregular', sans-serif;\n  color: var(--text-light);\n}\n\nheader h1 {\n  font-family: 'Press Start 2P', sans-serif;\n  font-size: var(--step-3);\n  color: var(--accent);\n  text-align: center;\n  letter-spacing: 0.1em;\n  text-shadow: 0 0 20px rgba(246, 173, 85, 0.4);\n  margin-top: 1rem;\n  margin-bottom: 3rem;\n}\n\nmain {\n  display: flex;\n  align-items: center;\n  gap: 3rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.board-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.board-section h2 {\n  font-family: 'Press Start 2P', sans-serif;\n  font-size: var(--step-0);\n  color: var(--miss-color);\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n#human-board,\n#computer-board {\n  display: grid;\n  grid-template-columns: repeat(10, 1fr);\n  width: fit-content;\n  border: 2px solid var(--wave);\n  border-radius: 4px;\n  box-shadow: 0 0 30px rgba(30, 95, 142, 0.4);\n}\n\n.cell {\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--cell-border);\n  background-color: var(--ocean-mid);\n  transition: background-color 0.2s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n#computer-board .cell:hover {\n  background-color: var(--wave);\n  cursor: crosshair;\n}\n\n.ship {\n  background-color: var(--ship-color);\n  background-image: linear-gradient(135deg, #5a6578 0%, #3d4552 100%);\n}\n\n.miss {\n  background-color: var(--miss-color);\n  background-image: radial-gradient(circle, #90cdf4 0%, #63b3ed 100%);\n  animation: splash 0.4s ease-out;\n}\n\n.hit {\n  background-color: var(--hit-color);\n  background-image: radial-gradient(circle, #fc8181 0%, #c53030 100%);\n  animation: explosion 0.4s ease-out;\n}\n\n.hit::after {\n  content: '💥';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 1.1rem;\n  animation: pop 0.4s ease-out forwards;\n}\n\n.miss::after {\n  content: '💧';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 0.9rem;\n  animation: pop 0.4s ease-out forwards;\n}\n\n.preview {\n  background-color: var(--preview-color) !important;\n}\n\n.preview-invalid {\n  background-color: var(--preview-invalid-color) !important;\n}\n\n/* Animations */\n@keyframes splash {\n  0% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes explosion {\n  0% {\n    transform: scale(0.5);\n    opacity: 0.5;\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes pop {\n  0% {\n    transform: translate(-50%, -50%) scale(0);\n    opacity: 1;\n  }\n  70% {\n    transform: translate(-50%, -50%) scale(1.2);\n    opacity: 1;\n  }\n  100% {\n    transform: translate(-50%, -50%) scale(1);\n    opacity: 1;\n  }\n}\n\n/* Controls */\n.controls {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n#placement-info {\n  font-size: var(--step-0);\n  color: var(--accent);\n  text-align: center;\n  min-height: 2rem;\n}\n\nbutton {\n  padding: 0.6rem 1.4rem;\n  border: 2px solid var(--wave);\n  border-radius: 6px;\n  background-color: var(--ocean-light);\n  color: var(--text-light);\n  font-size: var(--step--1);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  letter-spacing: 0.05em;\n}\n\nbutton:hover {\n  background-color: var(--wave);\n  border-color: var(--accent);\n  color: var(--accent);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\nbutton:active {\n  transform: translateY(0);\n}\n\n/* Dialog */\ndialog {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  border: 2px solid var(--accent);\n  border-radius: 12px;\n  background-color: var(--ocean-dark);\n  color: var(--text-light);\n  padding: 2rem;\n  text-align: center;\n  font-family: 'antaregular', sans-serif;\n  font-size: var(--step-1);\n  box-shadow: 0 0 40px rgba(246, 173, 85, 0.3);\n  animation: dialogPop 0.3s ease-out;\n}\n\ndialog button {\n  margin-top: 1rem;\n  font-size: var(--step-0);\n}\n\ndialog::backdrop {\n  background-color: rgba(0, 0, 0, 0.7);\n}\n\n@keyframes dialogPop {\n  0% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
